// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "sportsbook-" + chunkId + "." + {"1670":"938b31f7a7afd8f3ad15","4000":"23cee0780c2f7a99f259","4066":"9f59438a140a4d49cd09","8984":"502063c829cab9e1531b","9576":"d4723aefd500838dc923"}[chunkId] + ".css";
};